document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-lookbook]');
  if (!root) return;

  const stage = root.querySelector('.lookbook__stage');
  const items = Array.from(stage.querySelectorAll('.lookbook__item'));
  const thumbs = Array.from(root.querySelectorAll('.lookbook__thumb'));
  const thumbsContainer = root.querySelector('.lookbook__thumbs');

  let currentIndex = 0;
  let isModalOpen = false;
  let lastMouseX = 0;

  const modal = document.createElement('div');
  modal.className = 'lookbook__modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('tabindex', '0');

  const modalContent = document.createElement('div');
  modalContent.className = 'lookbook__modal-content';

  const modalImg = document.createElement('img');
  modalImg.className = 'lookbook__modal-img';
  modalImg.setAttribute('role', 'presentation');

  modalContent.appendChild(modalImg);
  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  const openModal = (index) => {
    const img = items[index].querySelector('.lookbook__img');
    if (!img) return;

    modalImg.src = img.src;
    modalImg.setAttribute('alt', img.getAttribute('alt') || '');
    modal.classList.add('is-active');
    isModalOpen = true;
    document.body.style.overflow = 'hidden';

    modal.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-active');
    isModalOpen = false;
    document.body.style.overflow = '';
  };

  const updateModalImage = (index) => {
    const img = items[index].querySelector('.lookbook__img');
    if (!img) return;

    modalImg.src = img.src;
    modalImg.setAttribute('alt', img.getAttribute('alt') || '');
  };

  const activate = (i) => {
    const index = Math.max(0, Math.min(i, items.length - 1));
    items.forEach((el, k) => el.classList.toggle('is-active', k === index));
    thumbs.forEach((el, k) => el.classList.toggle('is-active', k === index));
    currentIndex = index;

    if (isModalOpen) {
      updateModalImage(index);
      updateCursor(lastMouseX);
    }

    if (thumbsContainer && thumbs[index]) {
      const thumbRect = thumbs[index].getBoundingClientRect();
      const containerRect = thumbsContainer.getBoundingClientRect();
      const scrollLeft =
        thumbsContainer.scrollLeft +
        (thumbRect.left - containerRect.left) -
        containerRect.width / 2 +
        thumbRect.width / 2;
      thumbsContainer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  };

  const isMobile =
    window.__isMobile ||
    (() => {
      return (
        window.innerWidth <= 1024 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    });

  const setMaxHeight = () => {
    if (!isMobile()) {
      stage.style.height = '';
      stage.style.minHeight = '';
      return;
    }

    let maxHeight = 0;
    const images = Array.from(stage.querySelectorAll('.lookbook__img'));

    images.forEach((img) => {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        const screenWidth = window.innerWidth;
        const calculatedHeight = screenWidth / aspectRatio;
        maxHeight = Math.max(maxHeight, calculatedHeight);
      }
    });

    if (maxHeight > 0) {
      stage.style.height = maxHeight + 'px';
      stage.style.minHeight = maxHeight + 'px';
    }
  };

  activate(0);

  items.forEach((item, index) => {
    item.addEventListener('click', (e) => {
      if (isMobile()) {
        return;
      }
      activate(index);
      openModal(index);
    });
  });

  const updateCursor = (clientX) => {
    if (!isModalOpen || clientX === undefined) return;

    const modalRect = modal.getBoundingClientRect();
    const mouseX = clientX;
    const centerX = modalRect.left + modalRect.width / 2;

    if (mouseX < centerX) {
      if (currentIndex === 0) {
        modal.style.cursor = 'default';
      } else {
        modal.style.cursor = 'w-resize';
      }
    } else {
      if (currentIndex === items.length - 1) {
        modal.style.cursor = 'default';
      } else {
        modal.style.cursor = 'e-resize';
      }
    }
  };

  modal.addEventListener('mousemove', (e) => {
    if (e.target === modalImg) {
      return;
    }

    lastMouseX = e.clientX;
    updateCursor(e.clientX);
  });

  modal.addEventListener('mouseleave', () => {
    modal.style.cursor = '';
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modalImg) {
      closeModal();
      return;
    }

    const modalRect = modal.getBoundingClientRect();
    const clickX = e.clientX;
    const centerX = modalRect.left + modalRect.width / 2;

    if (clickX < centerX) {
      if (currentIndex > 0) {
        activate(currentIndex - 1);
      }
    } else {
      if (currentIndex < items.length - 1) {
        activate(currentIndex + 1);
      }
    }
  });

  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeModal();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      if (currentIndex > 0) {
        activate(currentIndex - 1);
      }
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      if (currentIndex < items.length - 1) {
        activate(currentIndex + 1);
      }
    }
  });

  let modalStartX = 0;
  let modalDeltaX = 0;

  modal.addEventListener(
    'touchstart',
    (e) => {
      modalStartX = e.touches[0].clientX;
      modalDeltaX = 0;
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchmove',
    (e) => {
      modalDeltaX = e.touches[0].clientX - modalStartX;
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchend',
    () => {
      if (Math.abs(modalDeltaX) > 40) {
        let nextIndex;
        if (modalDeltaX < 0) {
          if (currentIndex < items.length - 1) {
            nextIndex = currentIndex + 1;
            activate(nextIndex);
          }
        } else {
          if (currentIndex > 0) {
            nextIndex = currentIndex - 1;
            activate(nextIndex);
          }
        }
      }
    },
    { passive: true }
  );

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = parseInt(btn.getAttribute('data-index') || '0', 10);
      activate(i);
    });
  });

  let startX = 0;
  let deltaX = 0;
  const onStart = (x) => {
    if (isModalOpen) return;
    startX = x;
    deltaX = 0;
  };
  const onMove = (x) => {
    if (isModalOpen) return;
    deltaX = x - startX;
  };
  const onEnd = () => {
    if (isModalOpen) return;
    if (Math.abs(deltaX) > 40) {
      let nextIndex = currentIndex + (deltaX < 0 ? 1 : -1);
      nextIndex = Math.max(0, Math.min(nextIndex, items.length - 1));
      activate(nextIndex);
    }
  };
  stage.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), {
    passive: true,
  });
  stage.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), {
    passive: true,
  });
  stage.addEventListener('touchend', onEnd, { passive: true });
});
